import {
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
  TextLabel,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import {
  DlpKeywordListModalNameEnum,
  DlpKeywordListModalState,
} from '../../type';
import { PolicyApi } from '@Apis';
import LoadingBtn from '@Components/Common/LoadingBtn';

export const DeleteModal = ({
  modalState,
  onClose,
  refreshTable,
}: {
  modalState: DlpKeywordListModalState;
  onClose: () => void;
  refreshTable: () => void;
}) => {
  const { t } = useTranslation(['common', 'policy']);

  const deleteDlpKeyword = async () => {
    try {
      await PolicyApi.deleteDlpKeywordById(modalState.data.cfgIndex);
      window.showNotification({
        titleMsg: t('policy.dataIdentifiers.keywordLists.deleteSuccessfully'),
        severity: 'success',
      });
    } catch (error: any) {
      console.error(error);
      const errorCode = error?.data?.error?.details?.[0]?.code;
      if (errorCode === -116) {
        window.showNotification({
          titleMsg: t('errors.policy.POLICY_API;DELETE_KEYWORD_FAILURE;-116', {
            param: modalState.data.dpKeywordName,
          }),
          severity: 'error',
        });
        return;
      }
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      refreshTable();
      onClose();
    }
  };

  if (modalState.name !== DlpKeywordListModalNameEnum.Delete) {
    return <></>;
  }
  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={modalState.name === DlpKeywordListModalNameEnum.Delete}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalBody>
          <Text>{t('policy.dataIdentifiers.keywordLists.deleteConfirm')}</Text>
          <Grid
            gridTemplateColumns="max-content auto"
            gridColumnGap="4px"
            gridRowGap="8px"
            pt="16px"
          >
            <TextLabel>{t('common.label.enterName')}:</TextLabel>
            <Text>{modalState.data.dpKeywordName}</Text>
            <TextLabel>{t('common.label.description')}:</TextLabel>
            <Text>{modalState.data.dpKeywordDesc}</Text>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn onClick={deleteDlpKeyword} variant="primary">
            {t('common.button.ok')}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
